// removed by extract-text-webpack-plugin
module.exports = {"list":"ConnectionsList__list___3N876","list-m":"ConnectionsList__list-m___24qC5"};